export default __webpack_public_path__ + "static/media/graduate-cap.06e470bd.svg";